import { BodyPart } from '../../api/services/body_parts/types.ts'
import { BodyMeasurementResponse } from '../../api/services/dd_panel_body_measurements/types.ts'
import { FormField } from '../../components/common/Table/DataEntryForm.tsx'
import { BodyMeasurementsTableColumn } from '../bodyMeasurementsTableSettings.tsx'

export const capitalizeFirstLetter = (value: string): string =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : value

export const getBodyPartName = (id: number, bodyParts: BodyPart[]) => {
  if (!bodyParts) return ''
  const colName = bodyParts.find((bp) => bp.id === id)?.name ?? ''

  return capitalizeFirstLetter(colName)
}

export const prepareFields = (
  columns: BodyMeasurementsTableColumn[],
  bodyParts: BodyPart[]
) => {
  const fields = columns
    .filter(
      (column) =>
        (column.showInForm === true || column.showInForm === undefined) &&
        Boolean(column.inputType)
    )
    .map((column) => {
      const formatedField: FormField = {
        name: column.accessor,
        label: column.formLabel ?? column.header,
        type: column.inputType ?? 'text',
        required: column.required ?? false,
        level: 1,
        levelLabel: '',
      }
      if (column.accessor === 'bmi') {
        formatedField.calculatedFrom = ['bm', 'bh']
        formatedField.calculate = (values) => {
          const bm = Number(values.bm ?? 0)
          const bh = Number(values.bh ?? 0)

          const bmi =  bm /  ((bh / 100) * (bh / 100))
          return bmi.toFixed(1)
        }
      }
      return formatedField
    })

  bodyParts?.forEach((bp) => {
    fields.push({
      name: `body_part_${bp.id}`,
      label: `${getBodyPartName(bp.id, bodyParts)} (cm)`,
      type: 'number',
      required: false,
      level: 2,
      levelLabel: 'Obwody ciała'
    })
  })
  return fields
}

export const prepareBodyMeasurementsWithAdditional = (
  data: BodyMeasurementResponse | null | undefined
) => {
  const apiData = data?.results ?? []
  const mergedData = [...apiData]

  return mergedData.map((measurement, index, array) => ({
    ...measurement,
    previousWeight:
      index < array.length - 1 ? array[index + 1].bm : array[index].bm
  }))
}

export const getTodayDateInputValue = () => {
  const today = new Date()

  return today.toISOString().split('T')[0]
}
